import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators,} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {MessageService} from 'primeng/api';
import {SelectItem} from 'primeng/api/selectitem';
import {UuidLicense} from "../../models/uuid-license.model";
import {UuidLicenseService} from "../../services/uuid-license.service";
import {MessageFormRefreshService} from "../subject/message-service-subject.service";

@Component({
  selector: 'iw-new-uuid',
  templateUrl: './iw-new-uuid.component.html',
})
export class IwNewUuidComponent {
  @Input()
  public display: boolean;
  @Input()
  public displayUpdate?: boolean;
  @Input()
  public displayUpdateOptions?: boolean;

  public uuidLicense: UuidLicense = new UuidLicense();

  @Input()
  public set uuidOptions(uuid: UuidLicense) {
    this.uuidLicense = uuid;
    this.initializeTenant(uuid);
  }

  @Input()
  public expirationDate: Date = new Date();
  @Input()
  public popUpName?: string;
  @Input()
  public status?: SelectItem[];
  @Output()
  public changeDisplay: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public updateTenant: EventEmitter<UuidLicense[]> = new EventEmitter<UuidLicense[]>();

  public showWarningMessageForFullUser: boolean;
  public showWarningMessageForAssistant: boolean;

  public get gestionFormName(): any {
    return this.form.controls['gestion'];
  }

  public get ipAddressFormName(): any {
    return this.form.controls['ipAddress'];
  }

  public get tenantFormName(): any {
    return this.form.controls['tenant'];
  }

  public get statusSelectedFormName(): any {
    return this.form.controls['statusSelected'];
  }

  public form: FormGroup;
  private tenant: FormControl = new FormControl('', Validators.required);
  private ipAddress: FormControl = new FormControl('', Validators.required);
  private gestion: FormControl = new FormControl('', Validators.required);
  private statusSelected: FormControl = new FormControl('', Validators.required);

  constructor(
    public readonly uuidLicenseService: UuidLicenseService,
    private messageService: MessageService,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private readonly refreshFormMessageService: MessageFormRefreshService,
  ) {
    this.form = this.formBuilder.group({
      tenant: this.tenant,
      gestion: this.gestion,
      ipAddress: this.ipAddress
    });
    this.display = true;
    this.showWarningMessageForAssistant = false;
    this.showWarningMessageForFullUser = false;
  }

  public initializeTenant(uuidLicense: UuidLicense) {
    if (uuidLicense && uuidLicense.uuid) {
      console.log('Uuid license is valid. ' + uuidLicense.uuid)
      this.displayUpdate = true;
    } else {
      this.displayUpdate = false;
    }
    console.log('isUpdate' + this.displayUpdate)
    console.log('initializing new uuid update' + uuidLicense.uuid)
    this.form = this.formBuilder.group({
      gestion: uuidLicense.tenant,
      tenant: uuidLicense.tenant,
      uuid: uuidLicense.uuid,
      ipAddress: uuidLicense.ipAddress,
      status: uuidLicense.status,
      statusSelected: uuidLicense.status,
    });
  }

  public save(): void {
    if (this.displayUpdate) {
      this.saveUpdate(this.uuidLicense);
    } else {
      this.saveUuidLicense(this.uuidLicense);
    }
  }

  public cancel(): void {
    this.form.reset();
    this.onBeforeDialogHide();
  }

  public onBeforeDialogHide(event?: Event): void {
    this.changeDisplay.emit(false);
    this.display = false;
    this.showWarningMessageForFullUser = false;
    this.showWarningMessageForAssistant = false;
  }

  public confirmButtonDisabled() {
    return this.ipAddressFormName.errors?.required ||
           this.tenantFormName.errors?.required ||
           this.gestionFormName.errors?.required;
  }

  public setTenant(value?: string) {
    if (value) {
      this.uuidLicense.tenant = value;
    }
  }

  public setGestion(value?: string) {
    if (value) {
      this.uuidLicense.gestion = value;
    }
  }

  public setIpAddress(value?: string) {
    if (value) {
      this.uuidLicense.ipAddress = value;
    }
  }

  public setStatusSelected(value?: string) {
    if (value) {
      this.uuidLicense.status = value;
    }
  }

  private saveUpdate(uuid: UuidLicense): void {
    this.uuidLicenseService.updateUuidLicense(uuid).subscribe(
      this.successStore(),
      this.errorStore(),
    );
    this.onBeforeDialogHide();
  }

  private saveUuidLicense(uuid: UuidLicense): void {
    this.uuidLicenseService.saveUuidLicense(uuid).subscribe(
      this.successStore(),
      this.errorStore(),
    );
    this.onBeforeDialogHide();
  }

  private errorStore() {
    return () => {
      setTimeout((): void => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('Error Message'),
          detail: this.translate.instant('Errors occurred - Update Uuid'),
        });
      }, 1000);
    };
  }

  private successStore() {
    return () => {
      setTimeout((): void => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('Success Message'),
          detail: this.translate.instant('Uuid Updated'),
        });
      }, 3000);
      this.refreshFormMessageService.sendMessage('uuid');
    };
  }
}
